// src/services/tokenService.js
import AuthService from './authService';
import { jwtDecode } from 'jwt-decode';

class TokenService {
    static isTokenExpiringSoon() {
        const token = AuthService.getToken();
        if (!token) return false;

        try {
            const decoded = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);
            
            // Refrescar si el token expira en menos de 5 minutos
            return decoded.exp - currentTime < 300;
        } catch (error) {
            // Si hay error decodificando, asumir que el token no es válido
            return true;
        }
    }

    static startTokenRefreshInterval(onLogout) {
        // Verificación inicial
        this.checkAndRefreshToken(onLogout);

        // Establecer un intervalo para verificar periódicamente
        const intervalId = setInterval(() => {
            this.checkAndRefreshToken(onLogout);
        }, 5 * 60 * 1000); // Cada 5 minutos

        // Devolver el ID del intervalo para poder limpiarlo si es necesario
        return intervalId;
    }

    static async checkAndRefreshToken(onLogout) {
        if (this.isTokenExpiringSoon()) {
            try {
                await AuthService.refreshToken();
            } catch (error) {
                // Si el refresh falla, ejecutar logout
                if (onLogout) {
                    onLogout();
                }
            }
        }
    }

    static stopTokenRefreshInterval(intervalId) {
        if (intervalId) {
            clearInterval(intervalId);
        }
    }
}

export default TokenService;